import {DateStringNullable, NullableKeys, todayDate} from '@fl/cmsch-fe-library';
import {opt} from 'ts-opt';

/** Form name used by the other-subject management modal. */
export const managementOtherSubjectFormName = 'managementOtherSubjectForm';

/** Admin other-subject-management form type. */
export type ManagementOtherSubjectFormTag =
    'ValidateCreateOtherSubjectBindingManager' | 'ValidateUpdateOtherSubjectBindingManager';

/** Admin other-subject-management form type. */
export interface ManagementOtherSubjectFormValues {
    /** Approval start date. */
    approvedFrom: DateStringNullable;
    /** Approval end date. */
    approvedTo: DateStringNullable;
    /** Selected subject id. */
    subjectId: number;
    /** Selected role ids. */
    roleIds: Array<number>;
    /** Selected user profile id, if any. */
    userProfileId: number | null;
    /** Existing other-subject binding role ids. */
    userProfileRoleIds: Array<number>;
    /** Backend validation tag. */
    tag: ManagementOtherSubjectFormTag;
}

/**
 * Default values for the other-subject management modal.
 *
 * @param userProfileId Selected user profile id, if any.
 * @param roleId Selected role id, if any.
 * @param subjectId Selected subject id, if any.
 * @returns Default other-subject-management form values.
 */
export const managementOtherSubjectFormInitialValues = (
    userProfileId: number | null,
    roleId: number | null,
    subjectId: number | null,
): NullableKeys<ManagementOtherSubjectFormValues> => ({
    approvedFrom: todayDate(),
    approvedTo: null,
    subjectId,
    roleIds: opt(roleId).toArray(),
    userProfileId,
    userProfileRoleIds: [],
    tag: 'ValidateCreateOtherSubjectBindingManager',
});
